import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import Select from "react-select";
import AuthContext from "../context/AuthContext";

function Wizard(props) {
  const [message, setMessage] = useState(null);

  let { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const [username, setusername] = useState("");
  const [subnotes, setnotes] = useState("-");
  const [firstname, setfirst] = useState("");
  const [lastname, setlast] = useState("");
  const [password, setpassword] = useState("");
  let [plans, setplans] = useState([]);
  const [plani, setplano] = useState("");
  const [connectivity, setcona] = useState("");
  const [sites, setSites] = useState([]);
  const [cores, setCores] = useState([]);
  const [wirelessAccessPoints, setWirelessAccessPoints] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const [selectedWirelessAccessPoint, setSelectedWirelessAccessPoint] =
    useState(null);
  const [selectedCore, setSelectedCore] = useState(null);

  const [cpeMacAddress, setCpeMacAddress] = useState(""); // <-- New state
  const [cpeError, setCpeError] = useState("");

  const [selectedSiteLabel, setSelectedSiteLabel] = useState("");

  const specialSites = ["AYSAR", "EZONE", "SAEED"];

  console.log(selectedCore);

  console.log(plani);
  const validate = () => {
    // First, check the basic fields
    if (!username || !firstname || !lastname || !plani || !connectivity) {
      return false;
    }

    // Wireless-specific validation
    if (connectivity === "Wireless") {
      // for special sites we don’t require an actual MAC
      if (specialSites.includes(selectedSiteLabel)) {
        return Boolean(selectedWirelessAccessPoint);
      }

      // otherwise require a real, valid MAC
      if (
        !selectedSite ||
        !selectedWirelessAccessPoint ||
        !isValidMacAddress(cpeMacAddress)
      ) {
        return false;
      }
      return true;
    }

    if (connectivity === "Fiber") {
      // For Fiber, validate that a core is selected.
      return Boolean(selectedCore);
    }

    return false; // Fallback (if connectivity is neither Wireless nor Fiber)
  };

  useEffect(() => {
    let isMounted = true;

    const getplans = async () => {
      try {
        const response = await Axios.get(`${API_URL}/radius/plans/internet`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200 && isMounted) {
          setplans(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getplans();

    // Fetch Sites and Cores
    const fetchSites = async () => {
      try {
        const response = await Axios.get(`${API_URL}/radius/sites/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: { username: user.username },
        });

        if (response.status === 200) {
          const options = response.data.map((item) => ({
            label: item.site_name,
            value: item.site_id,
          }));
          setSites(options);
        }
      } catch (error) {
        console.error("Error fetching sites:", error);
      }
    };

    const fetchCores = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/radius/fiber/cores/select/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: { username: user.username },
          }
        );

        if (response.status === 200) {
          const options = response.data.map((item) => ({
            label: item.code,
            value: item.core_id,
          }));
          setCores(options);
        }
      } catch (error) {
        console.error("Error fetching cores:", error);
      }
    };

    fetchSites();
    fetchCores();

    return () => {
      isMounted = false;
    };
  }, []);

  const fetchWirelessAccessPoints = async (siteName) => {
    try {
      const response = await Axios.get(
        `${API_URL}/radius/wirelessAccessPoint/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: { username: user.username, site: siteName },
        }
      );

      if (response.status === 200) {
        const options = response.data.map((item) => ({
          label: item.name,
          value: item.ap_id,
        }));
        setWirelessAccessPoints(options);

        if (specialSites.includes(siteName)) {
          const defaultOption = options.find((opt) => opt.label === siteName);
          if (defaultOption)
            setSelectedWirelessAccessPoint(defaultOption.value);
        }
      }
    } catch (error) {
      console.error("Error fetching wireless access points:", error);
    }
  };

  const plano = plans.map((item) => {
    const planNameWithoutSM = item.plan_name.replace("SM-", "");
    return {
      label: planNameWithoutSM,
      value: item.internet_plan_id,
    };
  });

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });

    // Close the modal after 3 seconds
    setTimeout(() => {
      props.closeModal();
    }, 1200);

    // Clear the message after 5 seconds
    setTimeout(() => {
      setMessage(null);
    }, 1000);
  };
  const cona = [
    { value: "Fiber", label: "Fiber" },
    { value: "Wireless", label: "Wireless" },
  ];

  let handleSubmit = async (e) => {
    let lowercasedUsername = username.toLowerCase();
    e.preventDefault();
    Axios.post(
      `${API_URL}/radius/wizard/`,
      {
        Action: "Post",
        username: lowercasedUsername,
        plan_id: plani,
        first_name: firstname,
        last_name: lastname,
        password: password,
        notes: subnotes,
        site_id: selectedSite?.value || null,
        wireless_access_point_id: selectedWirelessAccessPoint,
        core_id: selectedCore,
        userdealer: user.username,
        cpe_mac_address: cpeMacAddress, //New Param
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        showMessage("Creation successful!", "success"); // Show the success message
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.data.error) {
          showMessage(
            "Creation failed! " + error.response.data.error,
            "danger"
          );
        }
        //showMessage("Creation failed!", "danger");
      });
  };

  const isValidMacAddress = (value) => {
    const macRegex = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/;
    return macRegex.test(value);
  };

  useEffect(() => {
    setCpeError(
      cpeMacAddress && !isValidMacAddress(cpeMacAddress)
        ? "Invalid CPE MAC Address format"
        : ""
    );
  }, [cpeMacAddress]); // CPE MAC Address Validation Use Effect

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>
              First Name:
              <input
                className="form-control"
                type="text"
                value={firstname}
                required
                placeholder="First Name"
                onChange={(e) => {
                  setfirst(e.target.value);
                }}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Last Name:
              <input
                className="form-control"
                type="text"
                value={lastname}
                required
                placeholder="Last Name"
                onChange={(e) => setlast(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Username:
              <input
                className="form-control"
                type="text"
                value={username}
                required
                placeholder="Username"
                onChange={(e) => setusername(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Password:
              <input
                className="form-control"
                type="text"
                value={password}
                required
                placeholder="Password"
                onChange={(e) => setpassword(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Plan Name:
              <Select
                className="search-line"
                placeholder="Choose plan"
                options={plano}
                onChange={(opt) => setplano(opt.value)}
              />
            </label>
          </div>
          <label>
            Notes:
            <input
              className="form-control"
              type="text"
              value={subnotes}
              required
              placeholder="Notes"
              onChange={(e) => setnotes(e.target.value)}
            />
          </label>
          <label>
            Connectivity Option:
            <Select
              className="search-line"
              placeholder="Choose Option"
              options={cona}
              onChange={(opt) => setcona(opt.value)}
            />
          </label>
          {connectivity === "Wireless" && (
            <div className="form-group">
              <label>
                Select Site:
                <Select
                  className="search-line"
                  placeholder="Choose Site"
                  options={sites}
                  onChange={(opt) => {
                    // 1) Track both the value and the human‑readable label
                    setSelectedSite(opt);
                    setSelectedSiteLabel(opt.label);

                    // 2) Fetch the WAPs for this site
                    fetchWirelessAccessPoints(opt.label);

                    // 3) If this is a “special” site, force CPE MAC = "-"
                    if (specialSites.includes(opt.label)) {
                      setCpeMacAddress("-");
                    } else {
                      setCpeMacAddress("");
                    }
                  }}
                />
              </label>
            </div>
          )}
          {/* New HTML Parts */}
          {connectivity === "Wireless" &&
            selectedSite &&
            !specialSites.includes(selectedSiteLabel) && (
              <div className="form-group">
                <label>
                  Select Wireless Access Point:
                  <Select
                    className="search-line"
                    placeholder="Choose Wireless Access Point"
                    options={wirelessAccessPoints}
                    onChange={(opt) =>
                      setSelectedWirelessAccessPoint(opt.value)
                    }
                  />
                </label>
                <label>
                  CPE MAC Address:
                  <input
                    type="text"
                    className={`form-control ${cpeError ? "is-invalid" : ""}`}
                    style={{ width: "250px" }}
                    value={cpeMacAddress}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const rawNoCols = raw.replace(/:/g, "");
                      const cleaned = rawNoCols.replace(/[^0-9A-Fa-f]/g, "");

                      // if characters were dropped, it means a non‑hex was typed
                      setCpeError(cleaned.length !== rawNoCols.length);

                      // format into pairs + colons, uppercase, max 12 hex digits
                      let formatted = "";
                      for (let i = 0; i < cleaned.length && i < 12; i += 2) {
                        if (i > 0) formatted += ":";
                        formatted += cleaned.substring(i, i + 2).toUpperCase();
                      }
                      setCpeMacAddress(formatted);
                    }}
                    maxLength={17} // “AA:BB:CC:DD:EE:FF”
                    placeholder="Type  CPE MAC Address"
                  />
                </label>
                {cpeError && (
                  <div
                    className="invalid-feedback"
                    style={{ display: "block", fontSize: "0.85rem" }}
                  >
                    Only hexadecimal digits (0–9, A–F) are allowed.
                  </div>
                )}
              </div>
            )}
          {connectivity === "Fiber" && (
            <div className="form-group">
              <label>
                Select Core:
                <Select
                  className="search-line"
                  placeholder="Choose Core"
                  options={cores}
                  onChange={(opt) => setSelectedCore(opt.value)}
                />
              </label>
            </div>
          )}
          <div className="fo">
            <button
              type="submit"
              className="btn btn-primary btn-md"
              disabled={!validate()}
            >
              Create
            </button>
          </div>
        </form>
      </div>
      {/* Popup Message */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default Wizard;
